/* eslint camelcase: 0 */

import { Session as Data } from '@/typings/api/Session'
import { Model, createMessages } from '@/helpers/Model'


export class SessionModel extends Model<Data> {
  public static readonly page_title = createMessages({
    ...Model.page_title,
    list: 'Сессии',
  });

  public static readonly response_error = createMessages({
    ...Model.response_error,
    read_all: 'Ошибка загрузки сессий',
    logout: (data: SessionModel) => 'Ошибка логаута пользователя «{name}»'
      .replace('{name}', data.name || '...'),
  });

  public static getName(data: Data) {
    return data?.username ?? ''
  }
}
